export default __webpack_public_path__ + "static/media/su.513d1f20.jpg";